import { useAuthStore } from "@/stores/auth-store";

/**
 * Whether the loaded session contract grants one invoicing scope
 * (`invoice:read`, `invoice:create`, `invoice:export`, …).
 *
 * The invoicing scopes are not in `src/lib/permissions.ts`'s `Permission`
 * catalogue, so `usePermission` / `useLoadedPermission` cannot express them —
 * they would answer `false` for every invoicing scope no matter what the
 * session holds, which is how the signer "Pair a phone" button once hid itself
 * from every real admin. This reads the same wire field those hooks read for a
 * route scope: `grantedScopes` from `GET /v1/session/effective-access`.
 *
 * Fail-closed, exactly like `useSignerPairingAllowed`: until that contract has
 * loaded from the API (`source === "api"`) the answer is `false`, so a control
 * that issues a real request is never enabled on a fixture or an unloaded
 * session. This decides what the page *offers*; the service decides what it
 * *allows*, and a refusal is rendered, never worked around.
 */
export function useInvoicingScope(scope: string): boolean {
  const experience = useAuthStore((state) => state.experience);
  return experience.source === "api" && experience.grantedScopes.includes(scope);
}
